/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export const supportImageGrid = {
  default: "grid-col-1-15",
  "hero-overlay": "grid-col-m-1-2 grid-row-1-8 grid-col-2-14 ",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-2-10",
  "headline-hero-priority": "grid-col-2-14",
  "headline-sideway": "grid-col-8-15 grid-row-md-1-8"
};

export const supportCaptionGrid = {
  default: "grid-col-2-14 ",
  "hero-overlay": "grid-col-m-1-2 grid-col-4-12 grid-row-m-8-9 grid-row-8-9 ",
  "hero-priority": "grid-col-3-13",
  "headline-priority": "grid-row-m-6-7 grid-col-2-10",
  "headline-hero-priority": "grid-col-4-12",
  "headline-sideway": " grid-row-m-8-9 grid-col-8-15"
};

export const supportHorizontalCaptionGrid = {
  "hero-priority": "grid-col-2-14"
};

export const supportSectionGrid = {
  default: "grid-col-2-10",
  "hero-overlay": "grid-col-m-1-2 grid-row-2-3 grid-col-3-13",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-row-1-2 grid-col-2-10",
  "headline-hero-priority": "grid-row-1-2 grid-col-3-13",
  "headline-sideway": "grid-row-m-1-2 grid-col-2-8 "
};

export const supportHorizontalGrid = {
  "hero-priority": "grid-col-3-13"
};

export const supportHorizontalTagMetypeGrid = {
  "hero-priority": "grid-col-4-12"
};

export const supportHeadlineGrid = {
  default: "grid-col-2-10",
  "hero-overlay": "grid-col-m-1-2 grid-col-3-13 grid-row-3-4",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-2-3",
  "headline-hero-priority": "grid-row-2-3 grid-col-3-13 ",
  "headline-sideway": "grid-col-2-8 grid-row-m-2-3"
};

export const supportSummaryGrid = {
  default: "grid-col-2-10",
  "hero-overlay": "grid-col-m-1-2 grid-col-3-13 grid-row-4-5 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-3-4",
  "headline-hero-priority": " grid-col-3-13 grid-row-3-4",
  "headline-sideway": "grid-col-2-8 grid-row-m-3-4"
};

export const supportAmazonPollyGrid = {
  default: "grid-col-2-10",
  "hero-overlay": "grid-col-m-1-2 grid-col-3-13 grid-row-5-6 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 grid-row-4-5",
  "headline-hero-priority": "grid-col-3-13 grid-row-4-5",
  "headline-sideway": "grid-row-m-4-5 grid-col-2-8"
};

export const supportAuthorGrid = {
  default: "grid-col-2-7 ",
  "hero-overlay": "grid-col-m-1-2 grid-col-3-13 grid-row-6-7 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-3-10 ",
  "headline-hero-priority": "grid-col-4-12",
  "headline-sideway": "grid-row-6-7 grid-col-2-8"
};

export const supportHorizontalAuthorGrid = {
  "hero-priority": "grid-col-3-7",
  "headline-priority": "grid-col-3-8",
  "headline-hero-priority": "grid-col-4-9"
};

export const supportSocialShareGrid = {
  default: "grid-col-7-10",
  "hero-overlay": "grid-col-m-1-2 grid-row-9-auto grid-col-d-3-4",
  "hero-priority": "grid-col-3-4 grid-row-3-auto",
  "headline-priority": "grid-col-2-3 grid-row-7-9",
  "headline-hero-priority": "grid-col-d-3-4 grid-row-6-auto",
  "headline-sideway": "grid-col-d-3-4 grid-row-9-auto"
};

export const supportHorizontalShareGrid = {
  "hero-priority": "grid-col-d-7-13",
  "headline-priority": "grid-col-8-10",
  "headline-hero-priority": "grid-col-9-12"
};

export const supportHorizontalLineGrid = {
  default: "grid-col-2-10"
};

export const supportReviewRatingGrid = {
  default: "grid-col-2-10",
  "hero-priority": "grid-col-4-12"
};

export const supportStoryTagGrid = {
  default: "grid-col-2-10",
  "hero-overlay": "grid-col-m-1-2 grid-col-4-12 ",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-3-10",
  "headline-hero-priority": "grid-col-4-12",
  "headline-sideway": "grid-col-m-1-auto grid-col-4-12"
};

export const supportRelatedStoryGrid = {
  default: "grid-row-3-12 grid-col-10-14",
  "hero-overlay": "grid-col-1-2 grid-col-2-14",
  "hero-priority": "grid-col-2-14",
  "headline-priority": "grid-col-10-14 grid-row-1-13",
  "headline-hero-priority": "grid-col-2-14",
  "headline-sideway": "grid-col-m-1-auto grid-col-2-14"
};

export const supportMetypeGrid = {
  default: "grid-col-2-10",
  "hero-overlay": "grid-col-m-1-2 grid-col-4-12",
  "hero-priority": "grid-col-4-12",
  "headline-priority": "grid-col-2-10 ",
  "headline-hero-priority": "grid-col-4-12",
  "headline-sideway": "grid-col-m-1-auto grid-col-4-12"
};
